import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungPotsdam() {
  return (
    <CityPageTemplate
      city="Potsdam"
      slug="potsdam"
      intro="In der Landeshauptstadt Brandenburgs direkt vor den Toren Berlins beraten wir Dich digital und unabhängig."
      description="Unabhängige & digitale Finanzberatung für Potsdam: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
